function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    text-align: center;\n    margin-top: 16px;\n    padding: 12em 0;\n    color: #353535;\n\n    h1 {\n        font-family: Poly;\n        font-weight: 500;\n        font-size: 40px;\n    }\n\n    p {\n        font-family: Montserrat;\n        font-size: 19px;\n    }\n\n    @media (max-width: 700px) {\n        h1 {\n            font-size: 26px;\n        }\n        p {\n            font-size: 18px;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import Button from '../shared/styleguide/Button';
function NotFound(param) {
    var _param_title = param.title, title = _param_title === void 0 ? '404 - Page Not Found' : _param_title, _param_message = param.message, message = _param_message === void 0 ? 'The page you were looking for could not be found' : _param_message;
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                children: message
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx(Button, {
                onClick: function onClick() {
                    return navigate('/user');
                },
                children: "Back"
            })
        ]
    });
}
export default NotFound;
var Container = styled.div(_templateObject());
